module.exports = __webpack_public_path__ + "img/list.dad5c754.svg";